var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"echart"}},[_c('div',{staticClass:"line",style:(_vm.lineBgSty)}),(_vm.main=='main1')?_c('div',{attrs:{"id":"main1"}}):_vm._e(),(_vm.main=='main2')?_c('div',{attrs:{"id":"main2"}}):_vm._e(),_c('div',{staticClass:"line",style:(_vm.lineBgSty)})])
}
var staticRenderFns = []

export { render, staticRenderFns }